import useCounter from './useCounter';
export default useCounter;
